import { openapi } from "../../../openapi";
import { setSelectedRoutingGraphIdInRedux, thunkToast } from "../designSlice";

export const graphApiEnhancer = openapi.enhanceEndpoints({
  endpoints: {
    getRoutingGraphList: {
      providesTags: ["routingGraphs"],
    },

    postRoutingGraphSave: {
      invalidatesTags: ["routingGraphs"],

      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(
            thunkToast({
              text: "Rør er lagret",
              header: "Suksess",
              isSuccess: true,
            }),
          );
        } catch (e) {
          dispatch(
            thunkToast({
              text: "Kunne ikke lagre rør",
              header: "Feil",
              isSuccess: false,
            }),
          );
        }
      },
    },

    deleteRoutingGraphDelete: {
      invalidatesTags: ["routingGraphs"],

      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(
            thunkToast({
              text: "Rør ble slettet",
              header: "Suksess",
              isSuccess: true,
            }),
          );
          dispatch(setSelectedRoutingGraphIdInRedux(null));
        } catch (e) {
          dispatch(
            thunkToast({
              text: "Kunne ikke slette rør",
              header: "Feil",
              isSuccess: false,
            }),
          );
        }
      },
    },
  },
});
